import { axiosInstance } from '../Config/axios';

const API_URL = 'v1/workflows/';
const API_DELETED_URL = 'v1/workflows-deleted/';
const API_COMPONENT_TYPES_URL = 'v1/workflows/config/component-types/';

export const getWorkflows = async (dependencyCode) => {
  try {
    const response = await axiosInstance.get(API_URL, {
      params: dependencyCode ? { dependency: dependencyCode } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener los workflows:', error);
    throw error;
  }
};

export const getWorkflowsByAsset = async (assetCode) => {
  try {
    const response = await axiosInstance.get(API_URL, {
      params: assetCode ? { asset: assetCode } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener los workflows del proceso:', error);
    throw error;
  }
};

export const getWorkflowByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el workflow ${code}:`, error);
    throw error;
  }
};

export const createWorkflow = async (data) => {
  try {
    const response = await axiosInstance.post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error('Error al crear el workflow:', error);
    throw error;
  }
};

export const updateWorkflow = async (code, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}${code}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al guardar el workflow ${code}:`, error);
    throw error;
  }
};

export const patchWorkflow = async (code, data) => {
  try {
    const response = await axiosInstance.patch(`${API_URL}${code}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar el workflow ${code}:`, error);
    throw error;
  }
};

export const deleteWorkflow = async (code) => {
  try {
    await axiosInstance.delete(`${API_URL}${code}/`);
  } catch (error) {
    console.error(`Error al eliminar el workflow ${code}:`, error);
    throw error;
  }
};

export const getComponentTypes = async (kind) => {
  try {
    const response = await axiosInstance.get(API_COMPONENT_TYPES_URL, {
      params: kind ? { kind } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener los tipos de componentes:', error);
    throw error;
  }
};

export const getWorkflowsDeleted = async () => {
  try {
    const response = await axiosInstance.get(API_DELETED_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los workflows eliminados:', error);
    throw error;
  }
};
